import styled from 'styled-components'
import { Select } from '@usap/uicomponents'

const SelectNoFocus = styled(Select)`
  font-size: 14px !important;
  
  padding: 20px 10px;
  color: #333;
  font-weight: normal;

  &:hover {
    box-shadow: none;
  }
  ::placeholder,
  ::-webkit-input-placeholder {
    color: black;
  }
  :-ms-input-placeholder {
    color: black;
  }
`

export default SelectNoFocus
